import { MapLabelMode, useCaMapEvents, useMapLabels } from "../../state";
import HouseNumberIcon from "../icons/house-number.svg?react";
import ParcelNumberIcon from "../icons/parcel-number.svg?react";
import { CustomControl } from "./CustomControl";

// Labels (kadastrale aanduidingen én huisnummers) verschijnen vanaf dit
// zoomniveau; daaronder heeft de switcher geen effect en blijft hij weg
export const LABEL_MINZOOM = 15;

const icon = {
  housenr: HouseNumberIcon,
  cadastre: ParcelNumberIcon,
};
const title: Record<MapLabelMode, string> = {
  cadastre: "Kadastrale aanduidingen — klik voor huisnummers",
  housenr: "Huisnummers — klik voor kadastrale aanduidingen",
};

// Wisselt de kaartlabels tussen kadastrale aanduidingen en huisnummers.
// Zelfde stijl als de andere maplibre-controls: één knop, het icoon toont
// de huidige stand en klikken wisselt om. Alleen zichtbaar wanneer de
// labels daadwerkelijk getoond (kunnen) worden.
export const LabelSwitchControl = () => {
  const [zoom] = useCaMapEvents("zoom");
  const mode = useMapLabels((s) => s.mode);
  const setMode = useMapLabels((s) => s.setMode);
  if (!zoom || zoom < LABEL_MINZOOM) return null;
  const Icon = icon[mode];
  return (
    <CustomControl position="bottom-right" first>
      <button
        type="button"
        title={title[mode]}
        aria-label={title[mode]}
        className="text-white flex items-center justify-center"
        onClick={() => setMode(mode === "cadastre" ? "housenr" : "cadastre")}
      >
        <Icon />
      </button>
    </CustomControl>
  );
};
